import React, { useEffect, useState } from "react";
import Snackbar from '@mui/material/Snackbar';
import _ from "underscore";

import NavBar from "../../components/nav-bar";
import SideBar from "../../components/sidebar";

function FarmRouting() {
    const [orderData, setOrderData] = useState([]);
    const [vendorData, setVendorData] = useState([]);
    const [vehicleData, setVehicleData] = useState([]);
    const [routingData, setRoutingData] = useState([]);
    const [showSnackbar, setShowSnackbar] = React.useState(false);
    const [snackbarMessage, setSnackbarMessage] = React.useState("");

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/farm_order`)
            .then(response => response.json())
            .then(json => {
                const openOrders = _.where(json, { status: "open" });
                setOrderData(openOrders);
            })
            .catch(error => console.error(error));

        fetch(`${process.env.REACT_APP_API_URL}/farm_transport`)
            .then(response => response.json())
            .then(json => {
                setVendorData(json);
            })
            .catch(error => console.error(error));

        fetch(`${process.env.REACT_APP_API_URL}/farm_transport_vehicles`)
            .then(response => response.json())
            .then(json => {
                const availableVehicles = _.where(json, { status: "available" });
                setVehicleData(availableVehicles);
            })
            .catch(error => console.error(error));
    }, []);

    useEffect(() => {
        if (orderData.length > 0 && vehicleData.length > 0) {
            fetch(`${process.env.REACT_APP_MODEL_API_URL}/farm-logistics`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    "orders": orderData,
                    "vehicles": vehicleData
                })
            })
                .then(response => response.json())
                .then(json => {
                    const dt = _.map(json, function (a) {
                        return { ...a, "isExpand": false };
                    });
                    setRoutingData(dt);
                })
                .catch(error => console.error(error));
        }
    }, [orderData, vehicleData])

    const expandTable = (orderNo) => {
        const b = _.map(routingData, function (a) {
            if (a.order_no === orderNo) {
                a.isExpand = !a.isExpand
            }
            return a;
        });
        setRoutingData(b);
    };

    const assignRouting = (data) => {
        // update order status
        fetch(`${process.env.REACT_APP_API_URL}/farm_order/${data.id}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "order_no": data.order_no,
                "farm_name": data.farm_name,
                "location": data.location,
                "quantity": data.quantity,
                "pickup_date": data.pickup_date,
                "status": "processed",
                "assigned_vehicles": _.pluck(data.vehicles, 'vehicle_no').toString()
            })
        })
            .then(response => response.json())
            .then(json => console.log(json))
            .catch(error => console.error(error));
        // update transport status , assigned_order, assigned_date
        for (let i = 0; i < data.vehicles.length; i++) {
            const element = data.vehicles[i];
            fetch(`${process.env.REACT_APP_API_URL}/farm_transport_vehicles/${element.id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    "vehicle_id": element.vehicle_id,
                    "vendor_id": element.vendor_id,
                    "vehicle_no": element.vehicle_no,
                    "vehicle_type": element.vehicle_type,
                    "location": element.location,
                    "capacity": element.capacity,
                    "status": "in-use",
                    "assigned_order": data.order_no,
                    "assigned_date": data.pickup_date
                })
            })
                .then(response => response.json())
                .then(json => console.log(json))
                .catch(error => console.error(error));
        }
        // remove from routing data
        var newRoutingData = _.reject(routingData, function (a) {
            return a.order_no === data.order_no;
        });
        setRoutingData(newRoutingData);
        setShowSnackbar(true);
        setSnackbarMessage("Order assigned successfully.");
    };

    const getRate = (data) => {
        const a = _.findWhere(vendorData, {
            vendor_id: data.vendor_id
        });
        return a.rate[data.vehicle_type];
    };

    return (
        <div className="container-fluid px-0 mb-5">
            <main id="main-layout" role="main" className="pb-3">
                <div className="enquiry-page-wrapper">
                    <NavBar title={"Routing"} />
                    <div className="container-fluid">
                        <div className="row">
                            <SideBar />

                            <div className="home-section">
                                <div className="col-lg-12 mb-2 pb-2" id="logContainer">
                                    <div className="row m-0 justify-content-between align-items-center">
                                        <div className="card-header p-0" style={{ borderBottom: "none" }}>
                                            {/* <ul className="nav nav-tabs justify-content-start common-view-tabs" role="tablist">
                                                <li className="nav-item common-view-item">
                                                    <a className="nav-link active common-view-link" data-status-id="0"
                                                        id="nav-Current-tab" data-toggle="tab" href="#nav-Current"
                                                        role="tab" aria-controls="nav-Current"
                                                        aria-selected="true">Scheduler</a>
                                                </li>
                                                <li className="nav-item common-view-item">
                                                    <a className="nav-link common-view-link" data-status-id="1"
                                                        id="nav-History-tab" data-toggle="tab" href="#nav-History"
                                                        role="tab" aria-controls="nav-History"
                                                        aria-selected="true">History</a>
                                                </li>
                                            </ul> */}
                                        </div>
                                        <div className="col-md-6 top-right d-flex justify-content-end align-items-end"
                                            style={{ gap: "10px" }}>
                                            {/* <div className="container-fluid">
                                                <input className="Enquiry-form-control" type="search" id="searchInput"
                                                    placeholder="Search by Process" />
                                            </div> */}
                                            {/* <div className="d-flex" style={{ gap: "10px" }}>
                                                <div>
                                                    <a role="button" className="c-black" href="/temp/Production Schedule.xlsx"
                                                        title="Download Report">
                                                        <i className="f-24 i-btn cursor-pointer ti ti-download"></i>
                                                    </a>
                                                </div>
                                                <a role="button" href="#" className="c-black" data-toggle="tooltip"
                                                    title="Filter" onClick="openSideFilterPanel()">
                                                    <i id="filter-icon" className="f-24 i-btn cursor-pointer ti ti-filter"></i>
                                                </a>
                                            </div> */}
                                            <div id="plan-insert-record">
                                                <i className="f-24 i-btn cursor-pointer ti ti-analyze" onClick={() => { setShowSnackbar(true); setSnackbarMessage("Auto assigning all the routings."); }}></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="tab-content mt-1" id="nav-tabContent">
                                        <div className="tab-pane fade show active" id="nav-Current" role="tabpanel"
                                            aria-labelledby="nav-Current-tab">
                                            <div id="list_content" className="table-responsive">
                                                <table className="table-list table-hover schedule-table" style={{ width: "100%" }}
                                                    id="plan-schedule-table">
                                                    <thead>
                                                        <tr className="table-list-header-row" style={{ color: "#ffffff" }}>
                                                            <th></th>
                                                            <th>Order No.</th>
                                                            <th>Farm Name</th>
                                                            <th>Quantity</th>
                                                            <th>PickUp Date</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody className="table-list-body">
                                                        {routingData?.map((dt, i) =>
                                                            <>
                                                                <tr className="table-list-body-row collapse plan-schedule-row show"
                                                                    id={`routing-data-` + i} key={`routing-data-` + i} data-id="1">
                                                                    <td>
                                                                        {!dt.isExpand &&
                                                                            <i className="f-24 i-btn cursor-pointer ti ti-fold-down" onClick={() => expandTable(dt.order_no)}></i>
                                                                        }
                                                                        {dt.isExpand &&
                                                                            <i className="f-24 i-btn cursor-pointer ti ti-fold-up" onClick={() => expandTable(dt.order_no)}></i>
                                                                        }
                                                                    </td>
                                                                    <td data-type="text" name="order_no">
                                                                        {dt.order_no}
                                                                    </td>
                                                                    <td data-type="text" name="farm_name">{dt.farm_name}</td>
                                                                    <td data-type="text" name="quantity">{dt.quantity}</td>
                                                                    <td data-type="text" name="pickup_date">{new Date(dt.pickup_date).toLocaleString()}</td>
                                                                </tr>
                                                                {dt.isExpand &&
                                                                    <>
                                                                        <tr id={`routing-data-sub-` + i} key={`routing-data-sub-` + i}>
                                                                            <td colSpan={5}>
                                                                                <div id="list_content" className="table-responsive" style={{ margin: "10px 0" }}>
                                                                                    <table className="table-list table-hover schedule-table" style={{ width: "100%" }}
                                                                                        id="plan-schedule-table">
                                                                                        <thead>
                                                                                            <tr className="table-list-header-row" style={{ color: "#ffffff" }}>
                                                                                                <th>Vehicle No.</th>
                                                                                                <th>Vehicle Type</th>
                                                                                                <th>Capacity</th>
                                                                                                <th>Rate</th>
                                                                                            </tr>
                                                                                        </thead>

                                                                                        <tbody className="table-list-body">
                                                                                            {dt?.vehicles.map((dt2, j) =>
                                                                                                <tr className="table-list-body-row collapse plan-schedule-row show"
                                                                                                    id={`vehicle-data-` + j} key={`vehicle-data-` + j} data-id="1">
                                                                                                    <td data-type="text" name="vehicle_no">{dt2.vehicle_no}</td>
                                                                                                    <td data-type="text" name="vehicle_type" style={{ textTransform: 'capitalize' }}>{dt2.vehicle_type}</td>
                                                                                                    <td data-type="text" name="capacity">{dt2.capacity}</td>
                                                                                                    <td data-type="text" name="rate">{getRate(dt2)}</td>
                                                                                                </tr>)}
                                                                                        </tbody>
                                                                                    </table>
                                                                                    <button className="btn btn-primary success" style={{ margin: '10px 0', float: 'right' }} onClick={() => assignRouting(dt)}>Assign</button>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    </>
                                                                }
                                                            </>)}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Snackbar
                        open={showSnackbar}
                        autoHideDuration={2000}
                        onClose={() => setShowSnackbar(false)}
                        message={snackbarMessage}
                    />
                </div>
            </main>
        </div>
    );
}
export default FarmRouting;